import { CatalogItemListRequest } from '@common/model/catalog/item/list.request';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ClientWebPageQueryParams } from '@common/model/meta/clientWebPageQueryParams';
import { ClientWebPageProps } from '@common/model/meta/clientWebPageProps';
import { DEFAULT_CATALOG_PAGE_NUMBER, DEFAULT_CATALOG_PER_PAGE } from '@common/const/catalog';

export const buildCatalogListRequest = ({
  pageProps,
  queryParams,
  cityId,
  pagination = DEFAULT_CATALOG_PER_PAGE,
}: {
  pageProps: ClientWebPageProps[ClientWebPage.Catalog];
  queryParams: Partial<ClientWebPageQueryParams<ClientWebPage.Catalog>>;
  cityId: ApiServerEntityIDType;
  pagination?: number;
}): CatalogItemListRequest => {
  const { catalogType, careerId, filter: filterFromRoute } = pageProps;
  const { page = DEFAULT_CATALOG_PAGE_NUMBER, filter: filterFromQuery, sorters } = queryParams;

  return {
    type: catalogType,
    careerId,
    cityId,
    page,
    sorters,
    pagination,
    filter: filterFromQuery ?? filterFromRoute,
  };
};
